import { Component, computed, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { AssistantFile } from '@core/models/assistant/assistant.model';
import { AssistantService } from '@core/services/assistant/assistant.service';
import { ICONS } from '@core/services/icons/icons.service';

import { AssistantReportService } from './assistant-report.service';
import { formatFileSize } from './assistant-report.utils';

@Component({
  selector: 'app-assistant-file-card',
  imports: [TranslatePipe],
  templateUrl: './assistant-file-card.component.html',
  styles: ``
})
export class AssistantFileCardComponent {
  readonly file = input.required<AssistantFile>();
  protected readonly assistant = inject(AssistantService);
  protected readonly reports = inject(AssistantReportService);
  protected readonly ICONS = ICONS;
  protected readonly available = computed(() => this.file().content !== null);
  protected readonly icon = computed(() =>
    this.file().format === 'markdown' ? ICONS.fileMd : ICONS.fileHtml
  );
  protected readonly meta = computed(
    () => `${this.file().filename} · ${formatFileSize(this.file().content ?? '')}`
  );
}
